/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuditType } from './AuditType';
import {
    AuditTypeFromJSON,
    AuditTypeFromJSONTyped,
    AuditTypeToJSON,
} from './AuditType';

/**
 * 
 * @export
 * @interface Audit
 */
export interface Audit {
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    readonly id: string;
    /**
     * 
     * @type {AuditType}
     * @memberof Audit
     */
    type: AuditType;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    recipient: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof Audit
     */
    created: Date;
}

/**
 * Check if a given object implements the Audit interface.
 */
export function instanceOfAudit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "recipient" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function AuditFromJSON(json: any): Audit {
    return AuditFromJSONTyped(json, false);
}

export function AuditFromJSONTyped(json: any, ignoreDiscriminator: boolean): Audit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': AuditTypeFromJSON(json['type']),
        'recipient': json['recipient'],
        'subject': json['subject'],
        'message': json['message'],
        'created': (new Date(json['created'])),
    };
}

export function AuditToJSON(value?: Audit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': AuditTypeToJSON(value.type),
        'recipient': value.recipient,
        'subject': value.subject,
        'message': value.message,
        'created': (value.created.toISOString()),
    };
}

